import { render, staticRenderFns } from "./ProductMain.vue?vue&type=template&id=21cd7750&scoped=true"
import script from "./ProductMain.vue?vue&type=script&lang=js"
export * from "./ProductMain.vue?vue&type=script&lang=js"
import style0 from "./ProductMain.vue?vue&type=style&index=0&id=21cd7750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cd7750",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CornerIcon: require('/vercel/path0/components/icons/CornerIcon.vue').default,CornerButton: require('/vercel/path0/components/shared/CornerButton.vue').default,HeartIcon: require('/vercel/path0/components/icons/HeartIcon.vue').default,ProductMainVariants: require('/vercel/path0/components/shared/product/ProductMainVariants.vue').default,ContainerContent: require('/vercel/path0/components/shared/ContainerContent.vue').default})
